import React from 'react';
import { Typography, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

/**
 * `column` pins the metric to a grid column so rows stay aligned when an
 * optional metric is missing (auto-placement only picks the row).
 */
function Metric({ label, value, tooltip, column }) {
  return (
    <div style={{ marginBottom: 18, gridColumn: column }}>
      <Text style={{ color: '#9CA3AF', fontSize: 12 }}>{label}</Text>
      <div
        style={{
          marginTop: 4,
          color: '#111827',
          fontSize: 13,
          display: 'flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <span>{value ?? '—'}</span>
        {tooltip ? (
          <Tooltip title={tooltip}>
            <QuestionCircleOutlined style={{ color: '#9CA3AF', cursor: 'help' }} />
          </Tooltip>
        ) : null}
      </div>
    </div>
  );
}

export default function ModelDetailsTrainingRunInfrastructure({
  instanceType,
  gpus,
  trainingTime,
  costEstimate = '-',
  trainingParams,
}) {
  return (
    <div>
      {trainingParams ? (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Title
              level={3}
              style={{
                marginTop: 0,
                marginBottom: 18,
                fontWeight: 600,
                color: '#111827',
              }}
            >
              Training Params
            </Title>
          </div>

          {/*
            Row 1: Training Device | Metric Optimisation | Optimize on
            Row 2: Prediction strategy | Fallback Prediction Behavior
            Each metric is pinned to its column so a missing optional metric
            leaves a gap instead of shifting its neighbours.
          */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              columnGap: 48,
              rowGap: 0,
            }}
          >
            <Metric column={1} label="Training Device" value={trainingParams.trainingDevice} />
            <Metric column={2} label="Metric Optimisation" value={trainingParams.metricOptimization} />
            {trainingParams.optimizeOn != null ? (
              <Metric column={3} label="Optimize on" value={trainingParams.optimizeOn} />
            ) : null}
            {trainingParams.predictionStrategy != null ? (
              <Metric column={1} label="Prediction strategy" value={trainingParams.predictionStrategy} />
            ) : null}
            {trainingParams.lowConfidenceHandling != null ? (
              <Metric
                column={2}
                label="Fallback Prediction Behavior"
                value={trainingParams.lowConfidenceHandling}
                tooltip={trainingParams.lowConfidenceTooltip}
              />
            ) : null}
          </div>

          <div style={{ height: 1, background: '#E5E7EB', width: '100%', margin: '10px 0 24px' }} />
        </div>
      ) : null}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Title
          level={3}
          style={{
            marginTop: 0,
            marginBottom: 18,
            fontWeight: 600,
            color: '#111827',
          }}
        >
          Training Run & Infrastructure
        </Title>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          columnGap: 48,
          rowGap: 0,
        }}
      >
        <div>
          <Metric label="Instance Type" value={instanceType} />
          <Metric label="Training & Evaluation Time" value={trainingTime} />
        </div>
        <div>
          <Metric label="GPUs" value={gpus} />
          <Metric label="Cost" value={costEstimate || '-'} />
        </div>
      </div>

      <div style={{ height: 1, background: '#E5E7EB', width: '100%', margin: '10px 0 24px' }} />
    </div>
  );
}

